const rankingItems = [
  {
    rank: 1,
    title: '重生之都市修仙',
    tag: '逆袭·热血',
    heat: '🔥 9.8w',
    update: '更新至186话',
    cover: 'https://readdy.ai/api/search-image?query=Dynamic%20manga%20portrait%20of%20a%20powerful%20young%20man%20with%20glowing%20eyes%20in%20modern%20cityscape%2C%20clean%20webtoon%20style%2C%20intense%20coral%20and%20dark%20tones%2C%20high%20quality%20character%20illustration&width=300&height=400&seq=rank-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '霸总的契约恋人',
    tag: '恋爱·都市',
    heat: '🔥 8.6w',
    update: '更新至203话',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20portrait%20of%20a%20beautiful%20woman%20in%20modern%20fashion%20with%20city%20night%20background%2C%20clean%20webtoon%20style%2C%20warm%20coral%20and%20gold%20tones%2C%20sophisticated%20character%20art&width=300&height=400&seq=rank-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '绝世剑神',
    tag: '奇幻·古风',
    heat: '🔥 7.5w',
    update: '更新至168话',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20manga%20portrait%20of%20a%20swordsman%20in%20ancient%20Chinese%20robes%20with%20spiritual%20energy%20aura%2C%20clean%20webtoon%20style%2C%20warm%20amber%20and%20dark%20tones%2C%20dramatic%20character%20illustration&width=300&height=400&seq=rank-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '我的女友是九尾狐',
    tag: '奇幻·恋爱',
    heat: '🔥 6.9w',
    update: '更新至145话',
    cover: 'https://readdy.ai/api/search-image?query=Whimsical%20manga%20portrait%20of%20a%20mystical%20fox%20girl%20with%20cherry%20blossoms%2C%20clean%20webtoon%20style%2C%20soft%20coral%20and%20pink%20tones%2C%20dreamy%20character%20illustration&width=300&height=400&seq=rank-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '穿越之王妃攻略',
    tag: '穿越·古风',
    heat: '🔥 6.2w',
    update: '更新至198话',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20portrait%20of%20a%20noble%20woman%20in%20ancient%20Chinese%20palace%20attire%2C%20clean%20webtoon%20style%2C%20warm%20gold%20and%20coral%20tones%2C%20regal%20character%20illustration&width=300&height=400&seq=rank-05&orientation=portrait',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热门榜单
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              布丁漫画下拉式阅读热度排行榜，发现大家都在追的热门漫画
            </p>
          </div>

          <div className="space-y-3">
            {rankingItems.map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-4 p-4 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full font-heading font-bold text-sm ${
                  i === 0 ? 'bg-accent-500 text-background-50' :
                  i === 1 ? 'bg-primary-500 text-background-50' :
                  i === 2 ? 'bg-primary-400 text-background-50' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="w-12 h-16 flex-shrink-0 rounded-lg overflow-hidden bg-background-100">
                  <img
                    src={item.cover}
                    alt={`布丁漫画热门 - ${item.title}`}
                    className="w-full h-full object-cover"
                    title={`布丁漫画下拉式看 ${item.title}`}
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1 truncate">
                    {item.title}
                  </h3>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.update}</span>
                  </div>
                </div>

                <div className="flex-shrink-0 text-right">
                  <div className="text-sm font-bold text-primary-500">{item.heat}</div>
                  <div className="text-xs text-foreground-400 mt-0.5 flex items-center gap-1">
                    <i className="ri-arrow-up-line text-accent-500"></i>
                    上升
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}